import { desanitizeKey } from '@/helper/utils';
import React from 'react';

interface ReviewDetails {
  notificationType: string;
  title: string;
  message: string;
  targetAudience: string;
  project?: string;
  site?: string;
  survey?: string;
  sendTime: string;
  sendDate: string;
  estimatedRecipients: number | null;
}

interface Props {
  details: ReviewDetails;
  isConfirmed: boolean;
  setIsConfirmed: React.Dispatch<React.SetStateAction<boolean>>;
  onSend: () => void;
  onSaveDraft: () => void;
  onPrevious: () => void;
  isEdit?: boolean;
}

export default function PreviewAndSend({ details, isConfirmed, setIsConfirmed, isEdit }: Props) {
  return (
    <div className=" w-full mx-auto ">
      <div className="border-b border-[#87074C] p-6 ">
        <h2 className="text-2xl font-bold text-[#621C43]">
          {isEdit ? 'Review & Update' : 'Review & Create'}
        </h2>
        <p className="text-lg  font-medium text-[#621C43]">
          Review all information before creating the Notification.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 px-5 pt-2">
        <div className="bg-[#FAF8F9] p-4 rounded-xl shadow border border-[#E5DDE0]">
          <h3 className="font-medium text-[#4A082D] mb-3">Notification Details</h3>
          <div className="text-sm font-medium text-[#4A082D]">
            <DetailRow label="Notification type" value={details.notificationType} />
            <DetailRow label="Title" value={details.title} />
            <DetailRow label="Message" value={details.message} />
          </div>
        </div>

        <div className="bg-[#FAF8F9] p-4 rounded-xl shadow border border-[#E5DDE0]">
          <h3 className="font-medium text-[#4A082D] mb-3">Delivery Details</h3>
          <div className="text-sm font-medium text-[#4A082D]">
            <DetailRow label="Target Audience" value={desanitizeKey(details.targetAudience)} />
            <DetailRow label="Project" value={details.project || 'NA'} />
            <DetailRow label="Site" value={details.site || 'NA'} />
            <DetailRow label="Survey Set" value={details.survey || 'NA'} />
            <DetailRow label="Send time" value={details.sendTime} />
            <DetailRow label="Send date" value={details.sendDate} />
            <DetailRow label="Estimated Recipients" value={details.estimatedRecipients ?? 'NA'} />
          </div>
        </div>
      </div>

      <div className="px-5">
        <div className="bg-[#4A082D]/20 p-4 rounded-xl border border-[#4A082D]/20 mt-6">
          <label className="flex items-start text-sm text-[#4A082D] cursor-pointer">
            <input
              type="checkbox"
              className="mt-1 h-3 w-3 accent-[#621C43]"
              checked={isConfirmed}
              onChange={(e) => setIsConfirmed(e.target.checked)}
            />
            <span className="ml-2 font-medium leading-5">
              I confirm that I want to send this notification
              <br />
              <span className="text-xs font-light text-[#4A082D]">
                This action will send the notification to all targeted users and cannot be undone.
              </span>
            </span>
          </label>
        </div>
      </div>
    </div>
  );
}

function DetailRow({ label, value }: { label: string; value: string | number }) {
  return (
    <p className="flex justify-between">
      <span className="font-light ">{label}</span>
      <span>{value ?? 'NA'}</span>
    </p>
  );
}
